var config = {
  //本地路径
  apiUrl: 'https://ssx.fzjiading.com/api',//接口
  // apiUrl: 'http://localhost:8756',//接口
  tymhUrl: '/apiMwcz',
  fileUrl: 'http://127.0.0.1:8758/upload/toJstUpload',
  fileShowUrl: 'https://ssx.fzjiading.com/jdminio/jdbucket1/',
  viewUrl: 'https://ssx.fzjiading.com/szdp-front2',
  qdUrl: 'http://127.0.0.1:8299'
};

export default config;
